import { createTheme } from '@mui/material';
import {
  primary,
  secondary,
  text,
  error,
  info,
  warning,
  success,
  grey,
} from 'assets/colors/colors';
import { TypographyVariant } from 'theme';

export const auditLogTheme = createTheme({
  palette: {
    mode: 'light',
    primary,
    secondary,
    text,
    error,
    info,
    warning,
    success,
  },
  components: {
    MuiStepper: {
      styleOverrides: {
        root: {
          '& .MuiSvgIcon-root': {
            fontSize: '8px',
            color: grey.A200,
          },
          '& .MuiStepLabel-root': {
            paddingBottom: '0px',
            marginLeft: '9px',
          },
          '& .MuiStepContent-root': {
            paddingLeft: '12px',
            borderLeft: '2px dotted grey',
            paddingBottom: '5px',
          },
          '& .MuiStep-root:last-of-type .MuiStepContent-root': {
            borderLeft: 'none',
          },
          '& .MuiStepConnector-line': {
            display: 'none',
          },
        },
      },
    },
  },
  typography: TypographyVariant,
});
